/**
 * DISTRIBUTOR-ORDERS MODULE
 * Self-contained. Import only from /shared or within this module.
 * Do not import from other product modules directly.
 */

// Public entry point. The app composition root imports ONLY from here; nothing
// deep-imports this module's internals.
import DistributorOrders from "./routes/DistributorOrders.jsx";
import { getDashboardSummary } from "./utils/dashboardSummary.js";

export const distributorOrdersRoutes = [
  { path: "/distributor-orders", component: DistributorOrders },
];

// Listed on the support ticket form's "Area" dropdown (collected automatically).
export const moduleMeta = { key: "distributor-orders", label: "Distributor Orders" };

// Operations-hub (Home) contribution — shipped cases + orders needing a human.
// Collected automatically by the composition root. Added 2026-08-08 (backlog
// 240): this was the one shipped module that contributed nothing outward.
export const dashboardProvider = getDashboardSummary;
